import React from 'react';
import {DragDropContextStore} from './DragDropContextStore';

export const DragDropReactContext: React.Context<DragDropContextStore | null> =
  React.createContext<DragDropContextStore | null>(null);
